import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper/core';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.min.css';
import styled from 'styled-components';
import { useViewport } from '../../utils/viewport';
import { CarouselCard, CarouselDataItem } from './CarouselCard';

export type CarouselProps = {
  data: CarouselDataItem[];
};

const StyledSwiper = styled(Swiper)`
  margin-left: -${({ theme }) => theme.spacings[7].rem};
  margin-right: -${({ theme }) => theme.spacings[7].rem};

  .swiper-pagination {
    z-index: -1;
  }

  .swiper-pagination-bullet {
    background: ${({ theme }) => theme.colors.neutrals.solidGrays[6]};
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: ${({ theme }) => theme.colors.primary.graysBlue};
  }
`;

const SwiperContainerStyle = {
  paddingBottom: '33px',
};

const SwiperSlideStyle = {
  maxWidth: '170px',
};

const buildCarouselCard = ({
  label,
  name,
  toolTip,
  formattedValue,
  actualValue,
}: CarouselDataItem) => {
  return (
    <CarouselCard
      key={label || name}
      label={label}
      name={name}
      toolTip={toolTip}
      actualValue={actualValue}
      formattedValue={formattedValue}
    />
  );
};

export const Carousel: React.FC<CarouselProps> = ({ data }) => {
  const { isDesktop } = useViewport();
  SwiperCore.use([Pagination]);

  return (
    <StyledSwiper
      centeredSlides={!isDesktop}
      pagination={{ clickable: true }}
      slidesPerView={'auto'}
      spaceBetween={14}
      style={SwiperContainerStyle}
      slidesOffsetBefore={isDesktop ? 40 : 0}
      slidesOffsetAfter={isDesktop ? 40 : 0}
      watchOverflow
    >
      {data.map((item) => (
        <SwiperSlide style={SwiperSlideStyle}>
          {buildCarouselCard(item as CarouselDataItem)}
        </SwiperSlide>
      ))}
    </StyledSwiper>
  );
};
